

export default class CropIcons {
  static get SUGAR_CANE () {
      return '<agro-icons name="sugarcane" color="#fff" />';
  }

  static get SOY () {
      return '<agro-icons name="soybean" color="#fff" />';
  }

  static get CORN () {
      return '<agro-icons name="corn" color="#fff" />';
  }

  public static fromText(cropType: string) {
    if (cropType) {
      switch(cropType.toLocaleLowerCase()) { 
        case 'soy': { 
          return 'soybean';
        } 
        case 'sugar_cane':
        case 'sugarcane': { 
          return 'sugarcane';
        } 
        case 'corn':
        case 'winter_corn': { 
          return 'corn'; 
        } 
        default: { 
          return ''; 
        } 
      } 
    }
  }
}
